import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticEvent } from 'app/lib/analytic-event';
import { ApiService } from 'app/lib/api.service';
import { CrisisHotline, LocationService } from 'app/lib/location.service';
import { LogService } from 'app/lib/log.service';
import { UserService } from 'app/lib/user.service';
import { UtilityService } from 'app/lib/utility.service';
import { Organization } from 'app/models/organization';
import { User } from 'app/models/user';

@Component({
    selector: 'app-emergency-call-msg-modal',
    templateUrl: './emergency-call-msg-modal.component.html',
    styleUrls: ['./emergency-call-msg-modal.component.scss'],
    standalone: false
})
export class EmergencyCallMsgModalComponent implements OnInit {
    organization: Organization;
    user: User;
    popupText: any;
    contactDescription: string;
    contactGroupTelephone: string;
    contactGroupTextMsgNumber: string;
    isSmsSupported: boolean = false;
    isHotline: boolean = false;
    hotline: CrisisHotline;
    constructor(
        private log: LogService,
        private api: ApiService,
        private translate: TranslateService,
        private userService: UserService,
        private utilityService: UtilityService,
        private snackBar: MatSnackBar,
        private locationService: LocationService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        @Optional() public dialogRef: MatDialogRef<EmergencyCallMsgModalComponent>
    ) {
        this.isHotline = data.isHotline;
        this.translate.get('contact').subscribe((res: any) => {
            this.popupText = res;
        });
        this.isSmsSupported = this.utilityService.isSmsSupported();
    }

    ngOnInit(): void {
        this.user = this.userService.getUser();

        if (this.user?.primaryOrganization) {
            this.organization = this.user?.primaryOrganization;
            if (
                this.organization?.contactGroup?.telephone ||
                this.organization?.contactGroup?.textMessageNumber
            ) {
                this.contactGroupTelephone =
                    this.organization.contactGroup.telephone || '';
                this.contactGroupTextMsgNumber =
                    this.organization.contactGroup.textMessageNumber || '';
            } else {
                this.getHotlineNumber();
            }
        } else {
            this.getHotlineNumber();
        }
        this.contactDescription = this.getConatactDescription();
    }

    getHotlineNumber() {
        this.locationService.getLocation().subscribe(
            (data: any) => {
                this.hotline = this.locationService.getHelpline(
                    data.country,
                    data.regionName
                );
            },
            (error: any) => {
                this.hotline = this.locationService.getHelpline();
            }
        );
    }

    callOrMsgEmergencyConatct(type: string, number: string) {
        const telephoneFormatted = this.formatTelephone(number);
        if (type === 'call') {
            window.location.href = `tel:${telephoneFormatted}`;
        } else if (type === 'msg') {
            window.location.href = `sms:${telephoneFormatted}`;
        }
        this.contactLinkClicked(
            telephoneFormatted,
            !this.isHotline ? this.organization.contactGroup.id : ''
        );
    }

    getConatactDescription(): string {
        const hotLineText =
            this.user?.primaryOrganization &&
            this.user?.primaryOrganization?.settings['assessment'] ===
                'resilience'
                ? this.popupText?.popupEmergencyTextVeteran || ''
                : this.organization?.contactGroup?.getHelpDescription
                  ? this.organization?.contactGroup?.getHelpDescription
                  : this.popupText?.popupEmergencyHotlineCallOrMsg || '';
        return hotLineText;
    }

    contactLinkClicked(telephoneFormatted: string, contactGroupId?: any) {
        !this.isHotline
            ? this.log.event(AnalyticEvent.event.protocallNumberCalled)
            : this.log.event(AnalyticEvent.event.hotlineCalled);
        this.api
            .post('analytics/supportlineclick', {
                phoneNumber: telephoneFormatted,
                contactGroupId: contactGroupId,
            })
            .subscribe(
                (result: any) => {
                    this.log.debug('Activity logged');
                },
                (error: any) => {
                    this.log.debug(
                        'Something went wrong with the activity logger.'
                    );
                }
            );
    }

    formatTelephone(telephone: string) {
        let telephoneFormatted = telephone.replace(/\s/g, '');
        telephoneFormatted = telephoneFormatted.replace('-', '');
        telephoneFormatted = telephoneFormatted.replace('(', '');
        telephoneFormatted = telephoneFormatted.replace(')', '');
        telephoneFormatted = telephoneFormatted.replace(' ', '');

        return telephoneFormatted;
    }

    numberCopied(item: any) {
        navigator.clipboard.writeText(item);
        this.snackBar.open(this.popupText.copiedToclipboard, '', {
            duration: 2000,
            panelClass: 'center-text',
        });
    }
}
